import { GetAsrsServerProductsVm } from './get-asrs-server-products.vm';
import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getAsrsServerProducts = async (
  serverId: string,
  term: string | null,
  offset: string,
  callback: CallbackObject<GetAsrsServerProductsVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (term) {
    config.params.term = term;
  }

  try {
    const res: AxiosResponse = await instance.get(`/catalog/asrs/${serverId}`, config);
    callback.success(plainToClass(GetAsrsServerProductsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
